export default __webpack_public_path__ + "static/media/zyfw.d7cc29c3.jpg";